export default {
    menu: {
        dashboard: 'Πίνακας ελέγχου',
        users: 'Λίστα πελατών',
        transactions: 'Συναλλαγές',
        coupons: 'Κουπόνια προσφοράς',
        notifications: 'Ειδοποιήσεις',
        foods: 'Βάση δεδομένων Τροφίμων',
        marketplaceProfiles: 'vresdiatrofologo',
        educational: 'Athlisis Educational',
    },
    educational: {
        title: 'Athlisis Educational',
        subtitle: 'Στατιστικά εκπαιδευτικών χρηστών ανά εκπαιδευτικό ίδρυμα',
        allInstitutions: 'Όλα τα εκπαιδευτικά ιδρύματα',
        none: 'Δεν υπάρχουν φοιτητές ακόμη',
        cards: {
            students: 'Φοιτητές',
            athletes: 'Πελάτες',
            dietPlans: 'Διατροφικά πλάνα',
        },
        table: {
            institution: 'Εκπαιδευτικό ίδρυμα',
            entryYear: 'Έτος εισαγωγής',
        },
    },
    marketplaceProfiles: {
        title: 'Προφίλ Vresdiatrofologo',
        viewUsers: 'Προβολή χρηστών',
        published: 'Δημοσιευμένο',
        unpublished: 'Μη δημοσιευμένο',
        date: 'Ενεργοποιήθηκε',
        actions: {
            seeProfile: 'Προφίλ χρήστη',
            seePublic: 'Vresdiatrofologo',
        },
        counts: {
            total: 'Σύνολο',
            published: 'Δημοσιευμένα',
            unpublished: 'Μη δημοσιευμένα',
        },
        filters: {
            all: 'Όλα τα προφίλ',
            published: 'Μόνο δημοσιευμένα',
            unpublished: 'Μόνο μη δημοσιευμένα',
        },
    },
    dashboard: {
        customers: 'Εγγεγραμένοι πελάτες (με ή χωρίς συνδρομή)',
        active: 'Ενεργοί πελάτες (με συνδρομή)',
        inactive: 'Ανενεργοί πελάτες (με συνδρομή)',
        foods: 'Τρόφιμα',
        dps: 'Διατροφικά πλάνα',
        clientele: 'Πελάτες',
        viewUsers: 'Προβολή χρηστών',
        viewUser: 'Προβολή',
        sales: 'Πωλήσεις',
        renewals: 'Ανανεώσεις',
        salesTitle: 'Πωλήσεις & ανανεώσεις ανά έτος'
    },
    users: {
        title: 'Λίστα πελατών',
        subscription: 'Συνδρομή;',
        googleLogin: 'Google Login',
        subscriptionExpiry: 'Λήξη ετήσιας συνδρομής',
        date: 'Ημερομηνία δημιουργίας',
        filters: {
            all: 'Όλοι οι χρήστες',
            premiumActive: 'Ενεργοί πελάτες',
            premiumExpired: 'Ληγμένες συνδρομές',
            notPremium: 'Χωρίς συνδρομή',
            paused: 'Απενεργοποιημένοι'
        },
        actions: {
            activate: 'Ενεργοποίηση συνδρομής',
            extend: ' Επέκταση ετήσιας συνδρομής (1 έτος)',
            pause: 'Παύση λογαριασμού',
            resume: 'Επανενεργοποίηση λογαριασμού',
            changeMail: 'Αλλαγή e-mail',
            transactionHistory: 'Ιστορικό συναλλαγών χρήστη'
        },
        emailPlaceholder: 'Εισάγετε το νέο e-mail',
        changeMailBtn: 'Αλλαγή e-mail',
        activate: {
            title: 'Θέλετε σίγουρα να ενεργοποιήσετε τη συνδρομή;',
            body: 'Θα προστεθεί υποχρέωση ανανέωσης της συνδρομής μετά το 1 έτος',
            okText: 'Ενεργοποίηση',
            success: 'Ο χρήστης ενεγοποιήθηκε επιτυχώς'
        },
        extend: {
            title: 'Θέλετε σίγουρα να επεκτείνετε τη συνδρομή;',
            body: 'Θα προστεθεί 1 έτος στη συνδρομή του χρήστη',
            okText: 'Επέκταση',
            success: 'Η συνδρομή επεκτάθηκε επιτυχώς!'
        },
        pause: {
            title: 'Θέλετε σίγουρα να απενεργοποιήσετε τον λογαριασμό;',
            body: 'Ο χρήστης δεν θα μπορεί να συνδεθεί μέχρι να επανενεργοποιηθεί.'
        },
        unpause: {
            title: 'Θέλετε σίγουρα να επανενεργοποιήσετε τον λογαριασμό;',
            body: 'Ο χρήστης θα μπορεί ξανά να συνδεθεί.'
        },
        details: {
            tabs: {
                basic: 'Στοιχεία',
                education: 'Educational',
                transactions: 'Συναλλαγές'
            },
            back: 'Πίσω στη λίστα',
            loading: 'Φόρτωση...',
            overview: 'Στοιχεία χρήστη',
            subscription: 'Συνδρομή',
            transactions: 'Συναλλαγές',
            noTransactions: 'Δεν υπάρχουν συναλλαγές',
            phone: 'Τηλέφωνο',
            emailConfirmed: 'Επιβεβαιωμένο e-mail',
            paused: 'Απενεργοποιημένος',
            expired: 'Ληγμένη',
            instalmentsSettled: 'Εξοφλημένες δόσεις',
            instalments: 'Δόσεις',
            instalment: 'Δόση',
            status: 'Κατάσταση',
            dueDate: 'Ημ/νία λήξης',
            statuses: {
                PENDING: 'Εκκρεμεί',
                COMPLETED: 'Ολοκληρωμένη',
                FAILED: 'Αποτυχημένη',
                WAIVED: 'Διαγράφηκε'
            },
            education: {
                title: 'Εκπαιδευτικό ίδρυμα & όρια',
                notStudent: 'Ο χρήστης δεν ανήκει σε κάποιο εκπαιδευτικό ίδρυμα.',
                attach: 'Σύνδεση με εκπαιδευτικό ίδρυμα',
                remove: 'Αφαίρεση από εκπαιδευτικό ίδρυμα',
                institution: 'Εκπαιδευτικό ίδρυμα',
                entryYear: 'Έτος εισαγωγής',
                graduationYear: 'Αναμενόμενη αποφοίτηση',
                studentId: 'Αριθμός μητρώου',
                limits: 'Όρια λογαριασμού',
                limitsSource: 'προεπιλογές εκπαιδευτικού ιδρύματος',
                limitsHint: 'Κενό πεδίο = κληρονομεί το προεπιλεγμένο όριο του εκπαιδευτικού ιδρύματος.',
                editTitle: 'Στοιχεία φοιτητή',
                selectInstitution: 'Επιλέξτε εκπαιδευτικό ίδρυμα',
                sources: {
                    override: 'Προσαρμοσμένο',
                    institution: 'Προεπιλογή εκπαιδευτικού ιδρύματος',
                    default: 'Προεπιλογή συστήματος',
                    unlimited: 'Χωρίς όριο'
                },
                resources: {
                    athletes: 'Πελάτες',
                    dietPlans: 'Διατροφικά πλάνα',
                    recipes: 'Συνταγές',
                    foods: 'Τρόφιμα',
                    athleteDietPlans: 'Πλάνα ανά πελάτη'
                },
                removeConfirm: {
                    title: 'Αφαίρεση από το εκπαιδευτικό ίδρυμα;',
                    body: 'Ο χρήστης θα επανέλθει σε κανονικό λογαριασμό και θα πάψει να έχει φοιτητικά όρια. Το ιστορικό διατηρείται.'
                }
            }
        }
    },
    coupons: {
        ofCoupon: 'Κουπονιού',
        title: 'Κουπόνια Προσφοράς / Συνεργατών',
        code: 'Κωδικός κουπονιού',
        type: {
            title: 'Τύπος έκπτωσης',
            sale: 'Τιμή πώλησης (π.χ. 1240€)',
            percentage: 'Έκπτωση (π.χ. -100€)',
        },
        price: 'Τιμή αγοράς',
        partnerCode: 'Κωδικός συνεργάτη',
        partnerCodePlaceholder: 'Κωδικός πρόσβασης συνεργάτη (συστήνεται η δημιουργία του)',
    },
    transactions:{
        title: 'Λίστα συναλλαγών (ολοκληρωμένες πληρωμές μέσω Stripe)',
        invoiceDetails: 'Στοιχεία Τιμολόγησης',
        email: 'E-mail πελάτη',
        amount: 'Ποσό',
        datePayment: 'Ημερομηνία πληρωμής',
        types: {
            title: 'Είδος πληρωμής',
            renew: 'Ανανέωση',
            purchase: 'Αγορά λογισμικού',
            purchaseInstalment: 'Δόση αγοράς'
        },
        document: {
            title: 'Παραστατικό',
            invoice: 'Τιμολόγιο',
            receipt: 'Απόδειξη'
        },
        statusChange: {
            tooltip: 'Αλλαγή κατάστασης',
            title: 'Θέλετε σίγουρα να αλλάξετε την κατάσταση;',
            body: 'Η κατάσταση θα αλλάξει σε {status}.',
            toLabel: 'Αλλαγή σε {status}',
            okText: 'Αλλαγή'
        },
        dueDateChange: {
            tooltip: 'Αλλαγή ημερομηνίας λήξης',
            title: 'Αλλαγή ημ/νίας λήξης',
            label: 'Νέα ημερομηνία λήξης',
            placeholder: 'Επιλέξτε ημερομηνία',
            okText: 'Αποθήκευση',
            renewWarning: 'Θα ενημερωθεί και η ημ/νία λήξης της συνδρομής του χρήστη.'
        }
    },
    notifications: {
        title: 'Ενημερώσεις συστήματος',
        icon: 'Εικονίδιο',
        add: 'Προσθήκη ειδοποίησης',
        empty: 'Δεν υπάρχουν ενημερώσεις συστήματος',
        emptyText: 'Οι ενημερώσεις που δημιουργείς θα εμφανίζονται εδώ.',
        fieldTitle: 'Τίτλος ειδοποίησης',
        content: 'Κείμενο ειδοποίησης',
        default: 'Προεπιλεγμένο',
    },
    foods: {
        list: 'Λίστα',
        title: 'Τρόφιμα συστήματος',
    }

}